import ItemMdl from '@/models/Warehouse/WhItem'
import axios from 'axios'

//
import remove from './remove'

const createItem = async function(data) {
    try {
        let customer = new ItemMdl(data)
        let response = await customer.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const fetchItem = async function(itemId) {
    try {
        let item = await ItemMdl.find(itemId)
        return item.data
    } catch (error) {
        return error.response.data
    }
}

const updateItem = async function(payload) {
    try {
        //TODO: //change to constant route
        let response = await axios.put(
            process.env.VUE_APP_API_ROUTE + `/wh_item/${payload.id}`,
            {
                alias_name: payload.data.alias_name,
                cost_price: payload.data.cost_price,
                description: payload.data.description,
                have_decimal_quantity: payload.data.have_decimal_quantity,
                internal_code: payload.data.internal_code,
                is_consumable: payload.data.is_consumable,
                is_inventoriable: payload.data.is_inventoriable,
                is_repackaged: payload.data.is_repackaged,
                is_salable: payload.data.is_salable,
                is_seasonal: payload.data.is_seasonal,
                is_tax_free: payload.data.is_tax_free,
                minimum_stock: payload.data.minimum_stock,
                name: payload.data.name,
                sale_price: payload.data.sale_price,
                tags: payload.data.tags,
                uom_quantity: payload.data.uom_quantity,
                // upc_code : payload.data.upc_code,
                warranty_days: payload.data.warranty_days,
                wh_subfamily_id: payload.data.wh_subfamily_id,
                wh_unit_of_measurement_id:
                    payload.data.wh_unit_of_measurement_id,
            }
        )
        return response
    } catch (error) {
        return error.response.data
    }
}

// const deleteItem = async function(id) {
//     try {
//         let response = await axios.delete(
//             process.env.VUE_APP_API_ROUTE + `/wh_product/${id}`
//         )
//         return response
//     } catch (error) {
//         return error.response.data
//     }
// }

export default {
    createItem,
    fetchItem,
    updateItem,
    remove,
}
